import styled from 'styled-components';

export const TextArea = styled.textarea`
  resize: none;
`;
